import ajaxService from '@/server/api.js'
import NodeModel from '@/utils/nodeModel.js'
import BaseExport from '@/components/BaseExport'
import FileSaver from 'file-saver'
import moment from 'moment'
export default {
    components: {
        BaseExport
    },
    data() {
        return {
            cityData: [],
            cityDataModel: new NodeModel(),
            defaultCity: [],
            // 房企
            companyList: [], //全部房企列表
            companyDefaultObj: {}, //房企默认Obj
            dataNow: moment().format('YYYYMMDD')
        }
    },
    computed: {},
    async created() {
        await this.getCityData()
        await this.getCompanyList()

        this.initRouter()
    },
    methods: {
        // 获取城市列表（省份城市）
        async getCityData() {
            let res = await ajaxService.getProvinceAndCity()
            if (!res.ErrorCode) {
                let temp = res.Data.map((item) => {
                    let obj = {
                        sName: item.CName,
                        aChildren: item.aChild.map((item) => {
                            let temp = {
                                sName: item.CName
                            }
                            return temp
                        })
                    }
                    return obj
                })
                this.cityDataModel.loadData(temp)

                this.cityData = this.cityDataModel.aChildren
            }
        },
        // 所属城区选项变化
        valChange() {
            this.defaultCity = this.cityDataModel.getCheckedData()
            let _city = this.defaultCity.reduce((res, item) => {
                return [...res, ...item.aChildren.map((e) => e.sName)]
            }, [])
            console.log(_city)
            if (_city.length == 1) {
                _city = _city[0]
            }
            this.form.sCity = _city
        },
        // 清除所有已选城区
        clearAll() {
            this.cityData.forEach((item) => {
                item.setChecked(false)
            })
            this.valChange()
        },
        checkAll() {
            this.cityData.forEach((item) => {
                item.setChecked(true)
            })
            this.valChange()
        },
        // 删除第一个展示的选项
        delFirst(name) {
            let arr = name.split('/')
            let n = arr.length
            for (let item of this.cityData) {
                if (item.sName == arr[0]) {
                    for (let city of item.aChildren) {
                        if (city.sName == arr[1]) {
                            city.setChecked(false)
                            this.valChange()
                        }
                    }
                }
            }
        },
        // 初始化默认城区选项
        setCityByDefaultCity(val) {
            for (let item of this.cityData) {
                for (let city of item.aChildren) {
                    if (city.sName == val || city.sName.indexOf(val) != -1) {
                        city.setChecked(true)
                        this.valChange()
                    }
                }
            }
        },

        // 房企
        // 获取全部房企
        async getCompanyList() {
            let res = await ajaxService.getCompany()
            // console.log('获取全部房企',res)
            if (!res.ErrorCode) {
                this.companyList = res.Data.map((item) => {
                    return {
                        // ...item,
                        label: item.ShortName,
                        value: item.ShortName
                    }
                })
            }
        },
        checkCompany(obj) {
            console.log(obj)
            this.companyDefaultObj = JSON.parse(JSON.stringify(obj))

            let _companyData = []
            if (this.companyDefaultObj.data) {
                if (this.companyDefaultObj.data.length == 1 && this.companyDefaultObj.data[0] == '全部房企') {
                    _companyData = this.companyList.map((item) => item.value)
                } else {
                    _companyData = this.companyDefaultObj.data
                }
            }
            this.form.sCompanyType = _companyData
        },
        // 初始化默认房企选项
        setCompanyByDefaultVal(val) {
            this.companyDefaultObj = {
                isMultiple: true,
                data: [val]
            }
        },
        // 导出
        exportData(val) {
            console.log(val)
            let param = {
                ...this.tableParam,
                iExport: 1,
                sExportType: val
            }
            this.getListData(param)
        },
        exportSet(res, name) {
            try {
                let enc = new TextDecoder('utf-8')
                res = JSON.parse(enc.decode(new Uint8Array(res))) //转化成json对象
                console.log(res)
                this.$message.error(res.ErrorMessage)
            } catch (err) {
                const fileName = name + this.dataNow
                let blob = new Blob([res], { type: 'application/vnd.ms-excel' })
                FileSaver.saveAs(blob, fileName + '.xlsx')
            }
        }
    }
}
